/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';

export const InputTransparent = props => {
  const {
    initValue,
    getRef,
    type,
    onBlur,
    onChange,
    placeholder,
    className,
    resetValue,
    forcedValue,
  } = props;
  const [value, setValue] = useState(initValue || '');
  const customClassName = className || '';
  const hasCustomSpacing = /(^|\s)([mp][trblxy]?-[^\s]+)/.test(
    customClassName,
  );
  const spacingClass = hasCustomSpacing ? '' : 'm-1 px-1 py-05';

  const ref = useRef(null);

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  useEffect(() => {
    if (ref?.current && getRef) {
      getRef(ref);
    }
  }, [ref]);

  const handleChange = e => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    if (resetValue === '') {
      setValue('');
    }
  }, [resetValue]);

  useEffect(() => {
    if (forcedValue) {
      setValue(forcedValue);
    }
  }, [forcedValue]);

  return (
    <input
      onClick={() => {
        ref.current.focus();
      }}
      ref={ref}
      className={`bg-transparent border-0 text-contrast text-opacity-80 flex-1 ${spacingClass} ${customClassName}`}
      placeholder={placeholder}
      value={value || ''}
      type={type ?? 'text'}
      onChange={e => handleChange(e)}
      onBlur={e => onBlur(value)}
      // autoFocus={true}
    />
  );
};
